import { render, staticRenderFns } from "./topicInfoCopy.vue?vue&type=template&id=4e30ad7d&scoped=true&"
import script from "./topicInfoCopy.vue?vue&type=script&lang=js&"
export * from "./topicInfoCopy.vue?vue&type=script&lang=js&"
import style0 from "./topicInfoCopy.vue?vue&type=style&index=0&id=4e30ad7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e30ad7d",
  null
  
)

export default component.exports